module.exports = __webpack_public_path__ + "img/gate_full.430e8742.jpg";